import type { SimulatorType } from "@/types/api/SimulatorType"
import type { SimulationMetadata } from "@/types/backend-contracts"
import type { RequiredKey } from "@/types/SimulatorConfig"
import { SIMULATOR_FIELDS } from "@/utils/simulation/simulatorFields"

import { getDefaultMetadataForSimulator } from "./simulatorDefaults"

export function getRequiredFieldsForSimulator(
  simulatorType: SimulatorType,
): RequiredKey[] {
  return SIMULATOR_FIELDS[simulatorType] ?? []
}

export function populateDefaultMetadataForSimulator(
  simulatorType: SimulatorType,
  existingMetadata: SimulationMetadata = {},
): SimulationMetadata {
  // Protocol defaults include fixed, non-editable values outside SIMULATOR_FIELDS; existing metadata wins so persisted agent configuration is never replaced.
  const updatedMetadata: SimulationMetadata = {
    ...getDefaultMetadataForSimulator(simulatorType, existingMetadata),
    ...existingMetadata,
  }

  getRequiredFieldsForSimulator(simulatorType).forEach((field) => {
    if (updatedMetadata[field.key] === undefined && field.default_value) {
      updatedMetadata[field.key] = field.option_values
        ? field.option_values[field.default_value] || field.default_value
        : field.default_value
    }
  })

  return updatedMetadata
}
